import React from 'react';
import { connect } from 'react-redux';
import DataTable from '@/components/DataTable/DataTable';
import { getTransactionHistoryAction } from '@/actions/trading';
import { dataType } from '@/constants/data-type';
import classnames from 'classnames';
import { getSafe } from '@/helpers/global';
import { PARAMS as requestParams } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import TabHeader from '@/components/TabHeader/TabHeader';
import { CUSTOM_STYLES, REFRESH_DATA } from '@/constants/app';
import { APP_LANGUAGE_SUPPORTS } from '@/constants/app';
import { Comparator, utilsFunction } from '@/helpers/functions';
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';

class TransactionHistory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      columnDefs: [
        {
          headerName: getSafe(() => this.props.language.common_reference_no),
          colId: 'common_reference_no',
          field: 'refID',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TEXT,
          minWidth: 160,
          maxWidth: 240
        },
        {
          headerName: getSafe(() => this.props.language.common_transaction_type),
          colId: 'common_transaction_type',
          field: 'transType',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TRANSACTION_HISTORY_STATUS,
          minWidth: 160,
          maxWidth: 240
        },
        {
          headerName: getSafe(() => this.props.language.common_transaction_date),
          colId: 'common_transaction_date',
          field: 'tradeDate',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.LONG_DATE,
          minWidth: 160,
          maxWidth: 240
        },
        {
          headerName: getSafe(() => this.props.language.common_symbol),
          colId: 'common_symbol',
          field: 'stockCode',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.SYMBOL,
          cellRendererParams: {
            market: 'marketID',
            instrument: 'stockCode'
          },
          minWidth: 100,
          maxWidth:120
        },
        {
          headerName: getSafe(() => this.props.language.common_name),
          colId: 'common_name',
          field: this.switchLanguageDataHeader(),
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.STOCK_NAME,
          tooltipField: utilsFunction.switchToolTipsLanguage(this.props.language, 'stockName', 'chineseStockName'),
          cellRendererParams: {
            stockName: 'stockName',
            chineseStockName: 'chineseStockName'
          },
          minWidth:260,
          maxWidth:350
        },
        {
          headerName: getSafe(() => this.props.language.common_price),
          colId: 'common_price',
          field: 'avgPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 130,
          maxWidth: 240
        },
        {
          headerName: getSafe(() => this.props.language.common_quantity),
          colId: 'common_quantity',
          field: 'qty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth:114,
          maxWidth:170
        },
        {
          headerName: getSafe(() => this.props.language.common_currency),
          colId: 'common_currency',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TEXT,
          minWidth: 50,
          maxWidth:100
        },
        {
          headerName: getSafe(() => this.props.language.common_amount),
          colId: 'common_amount',
          field: 'amount',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth:114,
          maxWidth:170
        }
      ],
      data: null,
      originData: null,
      startDate: '',
      endDate: '',
      type: '',
      ccy: '',
      maximumDate: {},
      transactionHistoryTable: [
        { id: 6, title: 'transaction_history_title', isActive: false },
      ],
      searchParams: {
        tranType: '',
        startDate: '',
        endDate: ''
      }
    }
  }

  dateFormat = ({ day, month, year }) => {
    return `${year}-${month}-${day}`
  }

  getTransactionHistory = () => {
    const { user, tradingAccount, language } = this.props;
    const { searchParams } = this.state;
    const { clientID } = tradingAccount;

    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      ...searchParams
      // [requestParams.TRADING_ACC_SEQ]: tradingAccSeq,
    }
    let timeout =  setTimeout(() => {
      this.TransactionHistoryRef.toggleLoadingOverlay(false);
      this.setState({data : [] })
      return
    }, 10000);

    this.TransactionHistoryRef.toggleLoadingOverlay(true);
    this.props.getTransactionHistoryAction(params, res => {
      clearTimeout(timeout)
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({ data: res.result.itemlist })
      } else {
        this.setState({ data: [] })
      }
      this.TransactionHistoryRef.toggleLoadingOverlay(false);
    })
  }

  switchLanguageDataHeader() {
    switch (this.props.language.lang) {
      case APP_LANGUAGE_SUPPORTS[1].id || APP_LANGUAGE_SUPPORTS[0].id: {
        return 'chineseStockName'
      }
      default: {
        return 'stockName'
      }
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  componentDidMount() {
    this.getMaximumDate();
    // this.getTransactionHistory()
  }

  componentDidUpdate(preProps, preState) {
    const { user, language,currentTradingAccount } = this.props
    if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getTransactionHistory()
    }
    if (preProps.user !== user) {
      this.getTransactionHistory()
    }
    if (preState.searchParams !== this.state.searchParams) {
      // this.getTransactionHistory()
    }
    if (preProps.language !== language) {
      this.getTransactionHistory()
    }
  }

  getMaximumDate() {
    let timer = ''
    let date = new Date();
    clearTimeout(timer)
    date.setDate(date.getDate() - 1); // get yesterday
    const maximumDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    }
    this.setState({
      maximumDate, searchParams: {
        tranType: this.tabHeaderTransactionHistoryRef.getTransactionHistoryValue(),
        startDate: this.convertDateObjectToString(maximumDate),
        endDate: this.convertDateObjectToString(maximumDate)
      }
    }, () => {
      timer = setTimeout(() => {
        this.tabHeaderTransactionHistoryRef.setDatePickerValue(this.state.maximumDate);
        this.getTransactionHistory()
      }, 0)
    })
  }

  handleChangeDatePicker = (date) => {
    const startDate = this.convertDateObjectToString(date.from);
    const endDate = this.convertDateObjectToString(date.to);
    const { searchParams } = this.state;
    if (startDate !== searchParams.startDate || endDate !== searchParams.endDate) {
      this.setState({
        searchParams: Object.assign({}, searchParams,
          {
            startDate,
            endDate
          })
      }, () => this.getTransactionHistory())
    }
  }

  handleFilter = (key) => {
    const { searchParams } = this.state;
    this.setState({ searchParams: Object.assign({}, searchParams, { tranType: key }) }, () => {
      this.getTransactionHistory();
    })
  }

  convertDateObjectToString(date) {
    return `${date.year}-${date.month}-${date.day}`
  }

  render() {
    const { columnDefs, data, maximumDate, transactionHistoryTable } = this.state
    const { language, theme } = this.props
    return (
      <React.Fragment>
        <div className={classnames("section-table", "transaction-history")}>
          <TabHeader
            innerRef={e => this.tabHeaderTransactionHistoryRef = e}
            tabs={transactionHistoryTable}
            refresh
            customStyle={CUSTOM_STYLES.HEADER_NORMAL}
            transactionHistoryFilter
            onSelectHistoryFilter={this.handleFilter}
            dateRangePicker
            data={data}
            exportExecl={{ fileName: 'TransactionHistory.xlsx' }}
            columnDefs={columnDefs}
            maximumDate={maximumDate}
            onChangeDatePicker={this.handleChangeDatePicker}
            onRefresh={this.getTransactionHistory}
          />
          <div style={{ width: '100%', flex: 1 }}>
            <DataTable
              name={TABLE_CONFIGURABLE_KEYS.MY_ACCOUNT_TRANSACTION_HISTORY}
              columnDefs={columnDefs}
              data={data}
              innerRef={e => this.TransactionHistoryRef = e}
            />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    theme: state.app.theme,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    tradingAccount: state.auth.tradingAccount
  }),
  dispatch => ({
    getTransactionHistoryAction: (p, c) => dispatch(getTransactionHistoryAction(p, c))
  })
)(TransactionHistory)
